export const LOAD_REPORT_DATA_REQUEST =
  "bonfire/lookups/LOAD_REPORT_DATA_REQUEST";
export const LOAD_REPORT_DATA = "bonfire/lookups/LOAD_REPORT_DATA";
export const LOAD_REPORT_DATA_SUCCESS =
  "bonfire/lookups/LOAD_REPORT_DATA_SUCCESS";
export const LOAD_REPORT_DATA_FAIL = "bonfire/lookups/LOAD_REPORT_DATA_FAIL";

interface LoadReportDataRequestAction {
  type: typeof LOAD_REPORT_DATA_REQUEST;
}

interface LoadReportDataAction {
  type: typeof LOAD_REPORT_DATA;
}

interface LoadReportDataSuccessAction {
  type: typeof LOAD_REPORT_DATA_SUCCESS;
  result: {
    data: any;
    site: string;
  };
}

interface LoadReportDataFailAction {
  type: typeof LOAD_REPORT_DATA_FAIL;
}

export type MonthlySummaryAction =
  | LoadReportDataRequestAction
  | LoadReportDataAction
  | LoadReportDataSuccessAction
  | LoadReportDataFailAction;
